import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Card, Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'src/utils/debounce';

import { getEarnings } from 'src/api/admin';
import { CONSTANTS } from 'src/commons';
import CustomTable from 'src/components/Table';
import Toolbar from 'src/components/member/Toolbar';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';

const Earnings = () => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user } = useSelector((state) => state.common);
  const [earnings, setEarnings] = useState([]);
  const [page, setPage] = useState(0);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    dispatch(startLoading());
    getEarnings(user)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS)
          console.log(res?.data, 'RESPONSE');
        setEarnings(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const onClickRow = () => {};

  const filterItem = debounce((text) => {
    setSearchInput(text?.trim());
  }, 200);

  const parsedData = useMemo(() => {
    const filteredData = earnings?.filter((query) =>
      query?.month?.toLowerCase()?.includes(searchInput?.toLowerCase())
    );
    return filteredData;
  }, [searchInput, earnings]);

  return (
    <>
      <Helmet>
        <title>Earnings | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            filterItem={filterItem}
            hideFilter
            hideAddButton={true}
          />
          <Box sx={{ pt: 3 }}>
            <Card>
              <CustomTable
                data={parsedData}
                dataKeysSequence={['month', 'totalEarnedAmount']}
                headers={['Month', 'Total EarnedAmount']}
                handlePageChange={handlePageChange}
                page={page}
                onClickRow={onClickRow}
              />
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Earnings;
